module.exports = __webpack_public_path__ + "img/34.ce4c3b3.jpg";